<template>
  <div class="container" style="padding-bottom: 20vh; padding-top: 100px;">
    <h1>New Blog Post</h1>
    <hr>
    <app-blog-post-form></app-blog-post-form>
  </div>
</template>

<script>
  import BlogPostForm from './BlogPostForm';

  export default {
    data() {
      return {

      }
    },
    components: {
      appBlogPostForm: BlogPostForm,
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/blog/NewBlogPost.vue